module.exports = __webpack_public_path__ + "static/img/merchant-icon.34e14cc9.png";